import React from 'react';
import CRUDManager from '../../../../shared/components/crud/CRUDManager';
import { vaccineRecordConfig } from '../config/vaccineRecordConfig';

export default function VaccineRecord() {
  return <CRUDManager config={vaccineRecordConfig} />;
}